import React from "react";
import "./Services.css";

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="services-container">

        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          We craft tailored digital solutions for your brand.
        </p>

        <div className="services-grid">
          {/* Card 1 */}
          <div className="service-card">
            <div className="icon">🖥</div>
            <h3>Static Websites</h3>
            <p>
              Fast, lightweight, and secure websites — perfect for portfolios,
              landing pages, and businesses that need a strong online presence.
            </p>
          </div>

          {/* Card 2 */}
          <div className="service-card">
            <div className="icon">⚡</div>
            <h3>Dynamic Websites</h3>
            <p>
              Fully functional websites with databases, authentication, and
              interactive features tailored to your business needs.
            </p>
          </div>

          {/* Card 3 */}
          <div className="service-card">
            <div className="icon">📱</div>
            <h3>Mobile Apps</h3>
            <p>
              Cross-platform mobile applications for Android and iOS, bringing
              your ideas directly to your customers’ fingertips.
            </p>
          </div>

          {/* Card 4 */}
          <div className="service-card">
            <div className="icon">🎨</div>
            <h3>Posters & Graphics</h3>
            <p>
              Creative posters, banners, and social media graphics to make your
              brand stand out visually.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;
